import styled from 'styled-components';

export default styled.footer`
  width: 100%;
  box-shadow: 0 -1px 0 0 rgba(47, 46, 65, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
`;
